const MIN_SIZE = 2000;
const SCALE_FACTOR = 400;

import 'leaflet/dist/leaflet.css';

var L = require('leaflet');
var topojson = require('topojson');
import fetch from 'unfetch';

import { resultTemplate } from './templates';

import LineChart from './linechart';

var config = require('../config');
var Utils = require('./utils');
var tooltip = require('./tooltip');
var markerColor = '#891E00';
var markerHighlightColor = '#004BC1';
var cityColor = '#707070';
var labels = [];
var initialZoom = Utils.geo.getZoomByWindowSize();

// pop circle options
var markerOptions = {stroke:false,fill:true, fillOpacity:.45, fillColor: markerColor, props: {}};
var markerOptions2 = {stroke:false, fill:true, fillOpacity:.5, fillColor: cityColor, radius: 1, className: 'city-circle', props: {}};

var lineOptions = {color : '#777', weight: 1, opacity:.8};

var $result = $('#result-wrapper');

var map, data;
var topPeopleGroup = false; 
var cityPointsGroup = false;
var selectedLayer = false;
var stateLayer = false;

var isMapMode = false;
var lineChart = null;

require('./vendor/leaflet.loading');

function init(_data){

  data = _data;

  map = L.map('map', config.map.options);
  resetView();

  L.tileLayer(`${config.map.tileLayer}&v=2`, {
      accessToken: config.map.accessToken,
      attributionControl: true,
      maxZoom: 19,
  }).addTo(map);

  L.control.zoom({position: 'bottomright'}).addTo(map);

  lineChart = new LineChart('#result-wrapper .result-linechart');

  map.on('click', activateMapMode);
  map.on('zoomstart', activateMapMode);
  map.on('dragstart', activateMapMode);
  map.on('zoomend', handleZoomEnd);

  var resetControl = L.Control.extend({
    options: {
      position: 'bottomright'
    },
    onAdd: function(map) {
      var container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom leaflet-reset-control');
      container.innerHTML = '<i class="icon_refresh"></i>'
      
      container.onclick = function(evt){
        evt.preventDefault();
        resetView();
      }
      return container;
    }
  });

  map.addControl(new resetControl());
  map.attributionControl.addAttribution(config.map.attribution);

  fetch('data/germany.topo.json')
    .then(res => res.json())
    .then(drawGermany);
}

function handleZoomEnd() {
  $('#map').toggleClass('is-zoomed', map.getZoom() !== initialZoom);
}

function drawCityPoints(){

  var cityPoints = [], circle;

  data.forEach((el,i) => {
    markerOptions2.props = $.extend(true, {}, el);
    markerOptions2.props.isCity = true;
    
    circle = L.circle([el.latitude,el.longitude], MIN_SIZE, markerOptions2);
    bindMouseEvents(circle);
    cityPoints.push(circle);
  });

  cityPointsGroup = L.featureGroup(cityPoints);
  cityPointsGroup.addTo(map);
}

function drawCircles(){

  var popCircles = [];
  var sortedData = data.sort(Utils.sortData('pop'));

  sortedData.forEach((el,i) => {
    markerOptions.props = $.extend(true, {}, el);
    markerOptions.props.isCity = false;

    popCircles.push(L.circle([el.latitude,el.longitude], getRadius(el.pop), markerOptions));
    
  });

  topPeopleGroup = L.featureGroup(popCircles);
  topPeopleGroup.eachLayer(bindMouseEvents);
  topPeopleGroup.addTo(map);
}

function drawGermany(data) {
  drawTopoJSON(data, 'states');
  drawTopoJSON(data, 'border');
  drawCircles();
  drawCityPoints();
  drawLabels();
}

function drawTopoJSON(data, object) {
  const feature = topojson.feature(data, data.objects[object]);
  const layer = new L.GeoJSON(feature, { style: () => ({ className: `topojson topojson-${object}` }) });
  layer.addTo(map);
}

function bindMouseEvents(layer){

  layer.on('mouseover', onHover);
  layer.on('mousemove', onMove);
  layer.on('mouseout', onOut);
  layer.on('click', onClick);
}

function onHover(evt){
  this.setStyle({
    weight: 2,
    opacity: 1,
    fillColor : markerHighlightColor
  });

  tooltip.update(this.options.props, this.options.fillColor);
}

function onMove(evt){
  tooltip.updatePos(evt);
}

function onOut(evt){
  tooltip.hide(evt);

  if(selectedLayer && (selectedLayer.options.props.name === evt.target.options.props.name)){
   return false;
  }

  this.setStyle({
    weight: 1,
    opacity: 1,
    fillColor : evt.target.options.props.isCity ? cityColor : markerColor
  });
}

function onClick(layer){

  var props = layer.target.options.props;
  var hrefs = Utils.createHrefs(props);

  props.hrefFb = hrefs.hrefFb;
  props.hrefTwitter = hrefs.hrefTwitter;

  $result.html(resultTemplate.render(props));
  $result.css('max-height', '500px');

  createLocator(props, '.result-locator');

  selectedLayer = layer.target;
  $('html').addClass('is-tt-exp');

  lineChart.render(props.hist);
}

function createLocator(d){

  if(window.innerWidth < 768){
    d.latitude -= .2;
  }

  if(window.innerWidth >= 768 && window.innerWidth < 1024) {
    d.longitude = +d.longitude + .5;
  }

  map.setView([d.latitude, d.longitude], 9);
  topPeopleGroup.eachLayer(layer => {
    if(layer.options.props.name === d.name){
      activateLayer(layer);
    }
  })
}

function resetLayer(layer){
  layer.setStyle({
    weight: 1,
    opacity: 1,
    fillColor : markerColor,
    color: markerColor
  });

  selectedLayer = false;
}

function activateLayer(layer){
  if(selectedLayer){
    deactivateLayer(selectedLayer);
    selectedLayer = false;
  }

  layer.setStyle({
    weight: 2,
    opacity: 1,
    fillColor : markerHighlightColor
  });

  selectedLayer = layer;
}

function deactivateLayer(layer){
  layer.setStyle({
    weight: 1,
    opacity: 1,
    fillColor : layer.options.props.isCity ? cityColor : markerColor
  });

  selectedLayer = false;
}

function activateMapMode(){
  switchMapMode(true);
}

function switchMapMode(isActive){
  isMapMode = isActive;
  $('html').toggleClass('is-map-mode', isMapMode);
  $('.intro').toggleClass('is-animated-headline', isMapMode);
}

function getRadius(pop){
  return Math.max(Math.sqrt(pop/Math.PI) * SCALE_FACTOR, MIN_SIZE);
}

function resetView(){
  var zoom = Utils.geo.getZoomByWindowSize();
  map.setView(config.map.center, zoom);
}

function resetAllMarkers(){
  topPeopleGroup.eachLayer(deactivateLayer);
  $('html').removeClass('is-tt-exp');
}

function drawLabels() {
  //remove old labels
  labels.forEach(label => {
    map.removeLayer(label);
  });

  labels = config.map.labels.forEach(label => {
    const className = 'map-label';
    const labelIcon = L.divIcon({
      className: className,
      html: label[0]
    });

    const labelEl = L.marker([label[2], label[1]], {
      icon: labelIcon
    }).addTo(map);

    return labelEl;
  });
}

module.exports = {
    init: init,
    createLocator: createLocator,
    reset: resetView,
    resetAllMarkers : resetAllMarkers
} 
